<template>
  <div>
    <CSidebarNavTitle v-translate v-if="hasAnyPerms('collaborator.list')">Administration</CSidebarNavTitle>
    <template>
      <CSidebarNavItem
          :name="$gettext('Collaborators')"
          :to="{name: 'event.collaborators', params: {picaServiceId: picaServiceId}}"
          icon="cip-add-user"
          v-if="hasPerm('collaborator.list')"
      />
    </template>
  </div>
</template>

<script>
import {mapGetters} from "vuex";

export default {
  name: 'InvitationsNav',
  computed: {
    ...mapGetters('event', [
      'picaServiceId'
    ]),
  }
}
</script>
  